import connectionProxy from "./connectionProxy";

export const getMenu = () => {
  return connectionProxy.http.get("/menu_items");
};



// WEBPACK FOOTER //
// ./src/api/menu.js